import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable, take } from 'rxjs';
import { SeminarDateSeriesListModel } from '../../../../models/seminar.model';
import { TopicCardModel } from '../../../../models/topic-card.model';
import { TrainingCategoryModel } from '../../../../models/training-category.model';
import { getSeminarLecturerText } from '../../../../utils/seminar.utils';
import { Filter } from '../../custom-table/custom-table.component';

@Component({
  selector: 'app-seminar-cards',
  templateUrl: './seminar-cards.component.html',
  styleUrl: './seminar-cards.component.scss',
  standalone: false,
})
export class SeminarCardsComponent implements OnChanges, OnInit {
  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: Event) {
    if (!this.filters || this.filters.length === 0) return;
    const filterMenu = this.el.nativeElement.querySelector('#filterMenu');
    const filterMenuButton =
      this.el.nativeElement.querySelector('#filterMenuButton');
    const isClickInside = filterMenu?.contains(event.target as HTMLElement);
    const isButtonClicked = filterMenuButton?.contains(
      event.target as HTMLElement
    );

    if (!isClickInside && !isButtonClicked && this.filterMenuOpen) {
      this.filterMenuOpen = false;
    }
  }

  @Input() dataSource$: Observable<SeminarDateSeriesListModel[]>;
  @Input() seminarsLoading = false;
  @Input() seminarCategory: TrainingCategoryModel;
  @Input() showSearch = true;

  public seminars: SeminarDateSeriesListModel[] = [];
  public filteredSeminars: SeminarDateSeriesListModel[] = [];
  public searchedAndFilteredSeminars: SeminarDateSeriesListModel[] = [];

  public searchQuery: string = '';

  public filterMenuOpen = false;

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  public ngOnInit(): void {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataSource$']) {
      this.dataSource$?.pipe(take(1)).subscribe(data => {
        this.seminars = [...data]; // save full data for filtering
        this.filteredSeminars = [...data]; // Start with the full data
        this.searchedAndFilteredSeminars = [...data]; // Start with the full data
        this.cdr.detectChanges();
      });
    }
  }

  public applySearch() {
    let filteredData = [...this.filteredSeminars];
    filteredData = this.applySearchFilters(filteredData);
    this.searchedAndFilteredSeminars = filteredData;
  }

  private applySearchFilters(
    data: SeminarDateSeriesListModel[]
  ): SeminarDateSeriesListModel[] {
    const query = this.searchQuery.toLowerCase();
    return data.filter(seminar =>
      Object.values(seminar).some(val => this.containsSearchQuery(val, query))
    );
  }

  private containsSearchQuery(val: any, query: string): boolean {
    if (typeof val === 'object' && val !== null) {
      return Object.entries(val).some(([key, nestedVal]) => {
        if (key.startsWith('color')) return false;
        return nestedVal?.toString()?.toLowerCase()?.includes(query);
      });
    }
    return val?.toString()?.toLowerCase()?.includes(query);
  }

  public getTopicCardValues(
    seminarDateSeries: SeminarDateSeriesListModel
  ): TopicCardModel {
    return {
      title: seminarDateSeries.seminar.title,
      subtitle: getSeminarLecturerText(seminarDateSeries),
      image: null,
      color50: this.seminarCategory?.color50,
      color0: this.seminarCategory?.color0,
      color70: this.seminarCategory?.color70,
      color80: this.seminarCategory?.color80,
      color90: this.seminarCategory?.color90,
    };
  }

  public onCourseClick(seminarDateSeries: SeminarDateSeriesListModel): void {
    this.router.navigate([
      'seminars',
      btoa(String(seminarDateSeries.seminar.id)),
      btoa(String(seminarDateSeries.dateSeriesId)),
    ]);
  }

  public onFilteredData(event: any) {
    this.filteredSeminars = event;

    this.applySearch();
  }

  public onFiltersChange(event: any) {
    this.filters = event;
  }

  public filters: Filter[] = [
    {
      filteredColumn: 'dates',
      type: 'daterange',
    },
    {
      filteredColumn: 'seminar.modality',
      type: 'select',
      selectOptions: [
        {
          value: 'online',
          label: 'Online',
        },
        {
          value: 'offline',
          label: 'Vor Ort',
        },
      ],
      placeholder: 'Ort auswählen...',
      label: 'Ort',
    },
  ];
}
